import {
  GET_MUSIC,
  GET_ONE_MUSIC,
  ADD_MUSIC,
  UPDATE_MUSIC,
  ERRORS,
} from "./musicTypes";

// action helper function
export const getAllMusicAction = (musics) => ({
  type: GET_MUSIC,
  payload: musics,
});

export const getMusicAction = (music) => ({
  type: GET_ONE_MUSIC,
  payload: music,
});

export const addMusicAction = (music) => ({ type: ADD_MUSIC, payload: music });

export const updateMusicAction = (music) => ({
  type: UPDATE_MUSIC,
  payload: music,
});

export const musicErrorAction = (error) => ({
  type: ERRORS,
  payload: error,
});
